const landingTypesList = [
  '/',
  '/fullPrice',
  '/trial',
];

export default landingTypesList;
